import * as React from 'react';
import { withStyles, createStyles, Theme } from '@material-ui/core/styles';
import CircularProgress from '@material-ui/core/CircularProgress';

const jss = (theme: Theme) => createStyles({
    container: {
        display: 'flex',
        flexWrap: 'wrap',
        width: '100%',
        height: '100%',
        flexDirection: 'column',
        justifyContent: 'center',
        alignItems: 'center',
    },
});

interface Props {
    classes: {
        container: string;
    }
}

class Loading extends React.Component<Props, any> {
  	render() {
        const { classes } = this.props;

        return (
            <div className={classes.container}>
                <CircularProgress size={100} />
            </div>
        );
	}
}

export default withStyles(jss)(Loading);



// WEBPACK FOOTER //
// ./src/components/Common/Loading.tsx